<template>
  <div class="rew19_infoImg">
    <img src="https://resource2018.nuskinkorea.co.kr/images/aro/info_smartBeauty_p.jpg"
         alt="스마트 뷰티 멤버십 스마트 뷰티 스타터 프로그램 스마트 뷰티 플러스 프로그램"
         usemap="#smartBeautyMap"
    />
<!--    <img src="https://resource2018.nuskinkorea.co.kr/images/aro/info_smartBeauty_p.jpg"
         alt="스마트 뷰티 멤버십 스마트 뷰티 스타터 프로그램 스마트 뷰티 플러스 프로그램"
         class="viewMb" usemap="#smartBeautyMap"
    />-->
    <map id="smartBeautyMap" name="smartBeautyMap">
      <area shape="rect" coords="66,446,453,372" href="https://www.nuskinkorea.co.kr/app/ro/aroShop/smartBeautyIntroduce" target="_self"  alt=""/>
      <area shape="rect" coords="641,448,1028,374" href="https://www.nuskinkorea.co.kr/app/ro/aroShop/fifteenthIntroduce" target="_self"  alt=""/>
    </map>
  </div>
</template>
<script>
export default {
  name: 'ProductListBanner15Per',
  components: {  },
  props: {},
  data() {
    return {
    }
  },
  mounted() {
    let _this = this;
  },
  methods :{
    onClickMoveIntroduce(){
      let _this = this;

      _this.$router.push(`${_this.$aroBasePath}/smartBeautyIntroduce`);
    }
  }
}
</script>
<style>
div.rew19_infoImg img{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/banner/ProductListBanner15Per.vue